/**
 * Canonical role naming.
 *
 * The product spec names four roles: `platform_admin`, `organization_owner`,
 * `organization_admin`, `organization_member`. The database and the
 * `OrganizationRole` type (see `types/tenancy.ts`) store the org-level ones
 * as the shorter `owner` | `admin` | `member` — that value only ever means
 * "role within an organization" in this codebase, so the `organization_`
 * prefix is implied rather than repeated in every column and type. This
 * map is the single place that spells out the full names, for UI copy and
 * documentation.
 */
export const ROLE_DISPLAY_NAMES = {
  platform_admin: "Platform admin",
  owner: "Organization owner",
  admin: "Organization admin",
  member: "Organization member",
} as const;

/** Full spec names, in case a route or script needs to emit them literally
 * (e.g. an audit log line or an external-facing API contract). */
export const FULL_ROLE_NAMES = {
  platform_admin: "platform_admin",
  owner: "organization_owner",
  admin: "organization_admin",
  member: "organization_member",
} as const;
